module.exports = __webpack_public_path__ + "static/media/teku-bg.98a69e3e.png";